export const BASE_URL = "https://api.neelkanthshivay.com/api";

